import styled from 'styled-components';

import Button from 'components/Button';
import Container from 'components/Container';
import FadeInImage from 'components/FadeInImage';
import { P } from 'components/Typography';

import { sizes } from 'style';
import { th, colors } from 'style/theme';

export const PartnersContainer = styled(Container)`
  display: grid;
  grid-template-columns: 100%;
  padding-top: 40px;

  ${P} {
    color: ${colors.black};
    margin: 16px 0;
  }

  @media ${sizes.desktop} {
    grid-template-columns: 25% 70%;
    grid-gap: 5%;
  }
`;

export const Bird = styled.div`
  display: none;

  @media ${sizes.desktop} {
    display: initial;
    align-self: flex-end;
    position: sticky;
    bottom: 80px;

    > img {
      width: 100%;
      max-width: 350px;
    }
  }
`;

export const Content = styled.div`
  color: ${colors.black};
  max-width: 750px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
`;

export const Header = styled.div`
  height: 200px;
  background-color: ${colors.white};

  > h1 {
    color: white;
    position: absolute;
    margin-top: 100px;
    margin-left: 40px;
  }
`;

export const SVGHeader = styled.svg`
  position: absolute;
  margin-top: 55px;
`;

export const Image = styled(FadeInImage)`
  width: 100%;
  max-width: 300px;
  align-self: center;

  @media ${sizes.tabletPortrait} {
    align-self: baseline;
    max-width: 35%;
  }

  @media ${sizes.desktop} {
    display: none;
  }
`;

export const Intro = styled.div`
  display: flex;
  flex-direction: column-reverse;
  margin-bottom: 30px;

  @media ${sizes.tabletPortrait} {
    flex-direction: row;
  }
`;

export const IntroText = styled.div``;

export const Line = styled.div`
  width: 100%;
  border-top: 1px solid ${colors.turquoise};
  margin: 40px 0;
`;

export const PartnersGrid = styled.div`
  grid-column: 1/4;
  padding: 60px 0;
  display: grid;
  grid-gap: ${th('space.8')}px;
  font-size: 14px;

  @media ${sizes.tabletPortrait} {
    padding: 40px 0 80px 0;
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media ${sizes.tabletLandscape} {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media ${sizes.desktop} {
    grid-column: 2/4;
  }

  @media ${sizes.largeDesktop} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;

export const Partner = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PartnerLink = styled.a`
  height: 30px;
`;

export const PartnerImage = styled.img`
  max-height: 30px;
  max-width: 125px;
  align-self: center;
`;

export const PartnerText = styled.p`
  margin-bottom: 0;
  line-height: 1.4;
`;

export const Row = styled.div`
  display: flex;
  margin: 20px 0 20px 40px;

  > ${P} {
    margin: 0 0 0 10px;
  }
`;

export const StyledButton = styled(Button)`
  margin-bottom: 20px;
`;
